module.exports = __webpack_public_path__ + "img/farmer-2.2941dce2.png";